<template>
  <div class="page manual">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{ 'help' | lang }}</div>
    </header>
    <div v-html="pageManualTranslated">
      <!-- <div class="multi-nav faq">
        <label class="unmanaged-nav-item">
          <input type="checkbox" />
          <div v-content-attached-on-top class="nav-header hflex">
              Questo è un esempio di domanda abbastanza lunga che potremmo anche vedere su più righe, soprattutto su mobile
          </div>
          <p>
            Questo è un esempio di risposta abbastanza lunga che potremmo anche vedere su più righe, soprattutto su mobile
          </p>
        </label>
        <label class="unmanaged-nav-item">
          <input type="checkbox" />
          <div v-content-attached-on-top class="nav-header hflex">
              Domanda 2
          </div>
          <p>
            Risposta 2
          </p>
        </label>
        <label class="unmanaged-nav-item">
          <input type="checkbox" />
          <div v-content-attached-on-top class="nav-header hflex">
              Domanda 3
          </div>
          <p>
            Risposta 3
          </p>
        </label>
      </div> -->
    </div>
  </div>
</template>

<script>
import page from '@/mixins/routeControl'

export default {
  name: 'Help',
  mixins: [ page ],
  computed: {
    pageManual () {
      return this.storeManifest.state.pageManual
    },
    pageManualTranslated () {
      if (this.pageManual) {
        return this.pageManual.replaceAll(/\{\{(\w+)\}\}/g, (regmatch, word) => {
          return this.dictValue(word)
        })
      }
      return null
    }
  }
}
</script>

<style lang="scss">
.page.manual {

  .nav-header, .jsfixedheader {
    color: var(--black);
    border-bottom: 2px solid var(--black);
    &::before {
      content: none;
    }
  }

  p {
    padding: .5rem 1.5rem;
  }

  .unmanaged-nav-item {

    input {
      opacity: 0;
      width: 0;
      height: 0;
      overflow: hidden;
      position: absolute;
    }

    input ~ p {
      display: none;
    }

    input:checked ~ p {
      display: inline-block;
      //padding-top: 1rem;
    }

    .nav-header {
      padding-right: 3rem;
      overflow: visible;
      margin-top: 1rem;
      position: relative;
    }
    .nav-header:after {
      content: "\F078";
      font: normal normal normal 14px/1 FontAwesome;
      font-size: inherit;
      text-rendering: auto;
      -webkit-font-smoothing: antialiased;
      position: absolute;
      right: .75rem;
      bottom: -1rem;
      border: 1px solid;
      border-radius: 50%;
      padding: .5rem;
      background: var(--white);
      z-index: 100;
    }
    input:checked ~ .nav-header:after {
      content: "\F077";
    }
  }
}
</style>
